import { useEffect, useState } from "react";
import axios from "../../axios";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function AboutUsPage() {
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        axios.get("/admin/about").then((res) => {
            if (res.data?.content) {
                const blocks = htmlToDraft(res.data.content);
                const contentState = ContentState.createFromBlockArray(
                    blocks.contentBlocks
                );
                setEditorState(EditorState.createWithContent(contentState));
            }
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSaved(false);
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));

        try {
            await axios.put("/admin/about", { content: html });
            setSaved(true);
        } catch (err) {
            alert("Gagal menyimpan konten.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card mt-4">
            <div className="card-header border-bottom">
                <h4 className="mb-0">Edit About Us</h4>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <Editor
                        editorState={editorState}
                        onEditorStateChange={setEditorState}
                        wrapperClassName="wysiwyg-wrapper"
                        editorClassName="wysiwyg-editor border p-2"
                        toolbar={{
                            options: ["inline", "list", "textAlign", "link", "history"],
                            inline: { options: ["bold", "italic", "underline"] },
                        }}
                    />
                    <button className="btn btn-primary mt-3" type="submit" disabled={loading}>
                        {loading ? "Menyimpan..." : "Simpan"}
                    </button>
                    {saved && <span className="text-success ms-3">✓ Tersimpan</span>}
                </form>
            </div>
        </div>
    );
}
